"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCorporateContactSchema = exports.createCorporateContactSchema = exports.corporateContactShape = exports.corporateContactRoleEnum = void 0;
const zod_1 = require("zod");
exports.corporateContactRoleEnum = zod_1.z.enum(['HR', 'ACCOUNTS', 'MEDICAL', 'PURCHASE', 'OTHER']);
exports.corporateContactShape = {
    corporateId: zod_1.z.string().uuid(),
    role: exports.corporateContactRoleEnum,
    name: zod_1.z.string().min(1).max(255),
    designation: zod_1.z.string().max(100).nullable().optional(),
    mobile: zod_1.z.string().max(20).nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    isPrimary: zod_1.z.boolean().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createCorporateContactSchema = zod_1.z.object(exports.corporateContactShape);
exports.updateCorporateContactSchema = exports.createCorporateContactSchema.partial();
//# sourceMappingURL=corporate-contact.schema.js.map